/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { InteractivityChecker } from '@angular/cdk/a11y';
import { Component, ElementRef, inject, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { ButtonComponent } from '../../../button/button.component';
import { FocusUtil } from '../../../focus.util';

@Component({
  selector: 'ods-form-list-item',
  imports: [ButtonComponent],
  host: {
    class: 'bg-background-150 flex w-full flex-row items-start justify-between gap-4 rounded-md p-4',
    '[attr.data-test-id]': 'dataTestId ? dataTestId + "-" + index : null',
    'attr.role': 'listitem',
  },
  template: `
    <div class="flex flex-1 flex-col gap-4">
      <ng-content />
    </div>
    @if (formArray.length > 1) {
      <ods-button
        variant="ghost"
        size="fit"
        [destructive]="true"
        icon="delete"
        [ariaLabel]="removeButtonLabel"
        (clicked)="remove()"
        [attr.data-test-id]="'remove-' + dataTestId + '-button-' + index"
      />
    }
  `,
})
export class FormListItemComponent {
  private readonly elementRef = inject(ElementRef);
  private readonly interactivityChecker = inject(InteractivityChecker);

  @Input({ required: true }) formArray: FormArray;
  @Input({ required: true }) index: number;
  @Input() removeButtonLabel: string = 'Entfernen';
  @Input() dataTestId: string = '';

  remove(): void {
    this.formArray.removeAt(this.index);
  }

  focus(): void {
    FocusUtil.getTabbableElement(this.elementRef.nativeElement, this.interactivityChecker).focus();
  }
}
